import ApiService from '../services/api.service'
import { AuditLogEntryModel } from './models'

export default {
  async loadAuditLogEntries(plcId: string): Promise<AuditLogEntryModel[]> {
    const response = await ApiService.get(`${ApiService.backendEnvironmentConfiguration().plcOperationQueryApi}/Audits/${plcId}/auditHistory`)
    return response.data.value
  },
}
